import { fetchWithAuth } from '../utils/fetchWithAuth';
import { API_BASE_URL } from '../config';
import * as Sentry from "@sentry/react";

export const authApi = {
  /**
   * Validate user session
   * @param {string} username - The username
   * @param {string} userId - The user ID
   * @returns {Promise<Object>} The response data with user and service desk info
   */
  validateSession: async (username, userId) => {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/me`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, userId })
      });

      const data = await response.json();

      if (!response.ok || !data?.success) {
        throw new Error(data.error || 'Session validation failed');
      }

      return {
        success: true,
        user: data.data.user,
        serviceDesk: data.data.serviceDesk,
        jiraBrowseBase: data.data.jiraBrowseBase
      };
    } catch (error) {
      const isAuthError = error.message?.includes('401') || error.message?.includes('403');

      if (!isAuthError) {
        Sentry.captureException(error, {
          level: 'error',
          tags: {
            error_context: 'session_validation',
            operation: 'validateSession'
          },
          extra: {
            username,
            hasUserId: !!userId
          }
        });
      }

      throw new Error(error.message || 'Failed to validate session');
    }
  }
};

